/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/buttons/invalidateAndEditButton"/>
import * as ko from "knockout";
import * as notification from "Core/Medius.Core.Web/Scripts/Medius/core/notification";
import * as globalization from "Core/Medius.Core.Web/Scripts/lib/globalization";
import { InvalidateAndEditButtonBase, IInvalidateAndEditHandler } from "../buttons/invalidateAndEditButtonBase";
import { isRejectionManagementEnabled } from "Core/Medius.Core.Web/Scripts/Medius/core/featureToggle";
import { RejectionManagementWizardType } from "../modals/rejectionManagementWizard/interfaces";
import * as rpc from "Core/Medius.Core.Web/Scripts/Medius/core/rpc";
import { getTypeName } from "Core/Medius.Core.Web/Scripts/Medius/core/type";
import { IRejectionWizardCloseEvent } from "../modals/rejectionManagementWizard/rejectionManagementWizard";

export class InvalidateAndEditButton extends InvalidateAndEditButtonBase {
    private invalidateTaskResult = "Invalidate";
    private invalidateAndEditTaskResult = "InvalidateAndEdit";
    private invalidateAndEditErrorLabelKey = "#Enterprise/InvalidateAndEditTaskResultUnavailable";

    constructor(handler: IInvalidateAndEditHandler, 
                isDisabled: ko.Observable<boolean>, 
                isInvaldiateAndEditHidden: ko.Observable<boolean> = ko.observable(false),
                isRejectionManagementEnabledInTheStep: ko.Observable<boolean> = ko.observable(false),
                companyId: number = -1) {
        super(handler, isDisabled, isInvaldiateAndEditHidden, isRejectionManagementEnabledInTheStep, companyId);
    }

    public invalidateAndEdit = () => {
        if(isRejectionManagementEnabled() && this.isRejectionManagementEnabledInTheStep() && this.reasonRequiredUponRejection()) {
            this.rejectionManagementWizardType = RejectionManagementWizardType.InvalidateAndEdit;
            this.isInvalidateModalVisible(false);

            const task = this.invalidateAndEditHandler.getTask();
            const currentDocumentType = getTypeName(task.Document().$type());

            rpc.ajax("UiDocumentManager", "GetDocumentReclassificationTypes").then(possibleReclassifyTypes => {
                this.openRejectionManagementWizardModal((closeEventDetails: IRejectionWizardCloseEvent) => {
                    if (closeEventDetails.wasConfirmed) {
                        this.invalidateAndReclassify(closeEventDetails.targetDocumentType);
                    }
                }, possibleReclassifyTypes, currentDocumentType);
            });
        }
        else{
            this.invalidateAndReclassify();
        }
    };

    private invalidateAndReclassify = (targetDocumentType?: string) =>{
            const task = this.invalidateAndEditHandler.getTask();

            //comments model taken from Document is new approach, taking it from step is legacy
            const commentsModel = task.Document().CommentsModel ?? task.CommentsModel;

            if (commentsModel.newComment()) {
                commentsModel.addComment();
            }

            const userTaskDto = this.invalidateAndEditHandler.getUserTaskDto();

            if (userTaskDto === undefined) {
                this.reclassifyEndTask(task, targetDocumentType);
            }
            else {
                const invalidateGroupResults = userTaskDto.AvailableGroupResults
                    .find((gr: { Code: string }) => gr.Code === this.invalidateTaskResult);
                if (invalidateGroupResults === undefined) {
                    notification.error(globalization.getLabelTranslation(this.invalidateAndEditErrorLabelKey));
                    return;
                }
                const invalidateAndEditResultDto = invalidateGroupResults.AvailableCopyResults
                    .find((cr: { Code: string }) => cr.Code === this.invalidateAndEditTaskResult);
                if (invalidateAndEditResultDto === undefined) {
                    notification.error(globalization.getLabelTranslation(this.invalidateAndEditErrorLabelKey));
                    return;
                }
                this.reclassify(task, invalidateAndEditResultDto, targetDocumentType);
            }

            this.isInvalidateModalVisible(false);
    };
}